export default __webpack_public_path__ + "static/latitudepay-decomission-banner-462c0bdca75e4836a170afe1bd055d2c.webp";